import whenDomReady from "when-dom-ready";
import renderFromPreloadedJSON from "~/common/renderFromPreloadedJSON";
import YouMayAlsoNeedPage from ".";

whenDomReady(() => {
  if (document.querySelector('[data-hypernova-key="YouMayAlsoNeedPage"]')) {
    renderFromPreloadedJSON(YouMayAlsoNeedPage, "YouMayAlsoNeedPage");
  }
});
